const normalizeHrefPath = (href = "") => {
  const base = String(href).split("#")[0];
  try {
    return decodeURIComponent(base);
  } catch (error) {
    return base;
  }
};

const hrefsMatch = (left = "", right = "") => {
  const a = normalizeHrefPath(left);
  const b = normalizeHrefPath(right);
  return Boolean(a && b && (a === b || a.endsWith(b) || b.endsWith(a)));
};

const getLinearSpineItems = (book) => {
  if (!book?.spine) return [];

  const items = [];
  try {
    book.spine.each((item) => {
      if (item?.linear !== false) items.push(item);
    });
  } catch (error) {
    return [];
  }
  return items;
};

export const getNextLinearSpineTarget = (book, activeHref = "", tocItems = []) => {
  const spineItems = getLinearSpineItems(book);
  const currentIndex = spineItems.findIndex((item) =>
    hrefsMatch(item?.href || "", activeHref)
  );
  if (currentIndex < 0 || currentIndex >= spineItems.length - 1) return null;

  const nextSpineItem = spineItems[currentIndex + 1];
  const tocMatch = tocItems.find((item) =>
    hrefsMatch(item?.href || "", nextSpineItem?.href || "")
  );

  return {
    href: nextSpineItem?.href || "",
    isChapterBoundary: Boolean(tocMatch),
    tocItem: tocMatch || null
  };
};

export const getLogicalTocItemForHref = (book, activeHref = "", tocItems = []) => {
  const spineItems = getLinearSpineItems(book);
  const currentIndex = spineItems.findIndex((item) =>
    hrefsMatch(item?.href || "", activeHref)
  );
  if (currentIndex < 0) return null;

  let closestItem = null;
  let closestIndex = -1;
  tocItems.forEach((tocItem) => {
    const tocSpineIndex = spineItems.findIndex((spineItem) =>
      hrefsMatch(spineItem?.href || "", tocItem?.href || "")
    );
    if (tocSpineIndex >= 0 && tocSpineIndex <= currentIndex && tocSpineIndex >= closestIndex) {
      closestItem = tocItem;
      closestIndex = tocSpineIndex;
    }
  });

  return closestItem;
};

export const getLogicalSpineGroup = (book, activeHref = "", tocItems = []) => {
  const spineItems = getLinearSpineItems(book);
  const currentIndex = spineItems.findIndex((item) =>
    hrefsMatch(item?.href || "", activeHref)
  );
  if (currentIndex < 0) return [];

  const tocSpineIndexes = tocItems
    .map((tocItem) =>
      spineItems.findIndex((spineItem) =>
        hrefsMatch(spineItem?.href || "", tocItem?.href || "")
      )
    )
    .filter((index) => index >= 0);
  const startIndex = tocSpineIndexes.reduce(
    (closest, index) =>
      index <= currentIndex && index > closest ? index : closest,
    -1
  );

  // Do not infer a chapter for unlisted front matter. A logical group must begin
  // at a real TOC entry; only its following unlisted spine files are continuations.
  if (startIndex < 0) return [spineItems[currentIndex]];

  const nextBoundaryIndex = tocSpineIndexes.reduce(
    (closest, index) =>
      index > startIndex && index < closest ? index : closest,
    spineItems.length
  );
  return spineItems.slice(startIndex, nextBoundaryIndex);
};
